<template>
	<label :for="inputIdString" v-cloak @drop.prevent="addFile" @dragover.prevent="showDragMessage" @dragleave="hideDragMessage"
		id="dragNDrop">
		<input :id="inputIdString" @change="addFileWithClick" type="file" class="d-none" :files="files"
			multiple />
		<h4>{{ title }}</h4>
		<div id="dropArea">
			<div class="dragHover" :class="{dragged: isDragged}">
				<h1>{{ fileDropTitle }}</h1>
			</div>
			<div class="regularTitle" v-if="!isDragged && !choseFiles">
				<h1>{{ regularTitle }}</h1>
			</div>
			<ul>
				<li v-for="(file,index) in files" :key="file.name">
					<div class="file text-center">
						<v-icon @click.prevent="removeFile(file, index)">mdi-close</v-icon>
						<v-icon size="60">mdi-file</v-icon>
						<span class="file-name" v-if="file.name">{{ file.name }}</span>
						<span class="file-name" v-else>{{ file.original_name }}</span>
						<span class="file-size" v-if="file.size">{{ file.size }} kb</span>
					</div>
				</li>
			</ul>
		</div>
	</label>
</template>
<script>
	export default {
		name: "drag-and-drop",
		props: {
			name: String,
			files: Array,
			removedFiles: Array,
			inputId: {default:"input"},
			title: {type: String, default: "העלאת קבצים"},
			fileDropTitle: {type: String, default: "שחררו עכבר להעלאת הקבצים"},
			regularTitle: {type: String, default: "לחצו על המלבן / גררו קבצים לכאן"}
		},
		data() {
			return {
				isDragged: false,
				choseFiles: false
			};
		},
		computed:{
			inputIdString(){
				if(typeof this.inputId === "number"){
					return this.inputId.toString();
				}
				return this.inputId;
			}
		},
		methods: {
			addFile(e) {
				this.hideDragMessage();
				let droppedFiles = e.dataTransfer.files;
				if (!droppedFiles) return;
				([...droppedFiles]).forEach(f => {
					this.files.push(f);
				});
				this.choseFiles = true;
			},
			addFileWithClick(e) {
				let files = e.target.files;
				([...files]).forEach(f => {
					this.files.push(f);
				});
				this.choseFiles = true;
			},
			removeFile(file, index) {
				if(file.id){
					this.removedFiles.push(file.id);
				}
				this.files.splice(index, 1);
				if (this.files.length === 0) {
					this.choseFiles = false;
				}
			},
			showDragMessage() {
				this.isDragged = true;
			},
			hideDragMessage() {
				this.isDragged = false;
			}
		},
	};
</script>

<style>
#dropArea {
  width: 100%;
  margin: auto;
  padding: 30px;
  border: 1px solid lightblue;
  min-height: 235px;
  position: relative;
}

.regularTitle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  down: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dragHover {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  down: 0;
  display: flex;
  background-color: rgb(0, 0, 0);
  justify-content: center;
  align-items: center;
  color: white;
  opacity: 0;
  transition: opacity .4s ease-in-out;
}

.dragHover.dragged {
  opacity: 0.85;
  z-index: 2;
}


.mdi-file {
  display: block !important;
}


ul {
  display: flex;
  justify-content: right;
  flex-wrap: wrap;
  list-style-type: none;
}

li {
  margin: 10px 20px;
  max-width: 200px;
}


.file {
  position: relative;
  border: 1px solid lightblue;
  border-radius: 10px;
  padding: 10px
}

.file .mdi-close {
  left: 40px;
  cursor: pointer;
}

.file-name {
  display: block;
}

.file-size {
  display: block;
}
</style>